import 'globalStyles/main.scss';

import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { useLocation, useRouteMatch } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import Container from 'components/Container';
import { client } from 'apollo/client';
import { muiTheme } from 'globalStyles/theme';
import CacheBuster from 'react-cache-buster';

import NotePreview from 'pages/Notes/NotePreview';
import Rollbar from 'components/Rollbar';
import App from './App';
import { PublicRoutes as Routes } from './routes';

export default function Main() {
  const location = useLocation();
  const isInvoicePage = location.pathname?.includes('/invoice/pay')
    || location.location?.pathname?.includes('/invoice/pay');
  const isEventPage = location.pathname?.includes('/our-wedding')
    || location.location?.pathname?.includes('/our-wedding')
    || location.pathname?.includes('/event')
    || location.location?.pathname?.includes('/event');
  const isProduction = process.env.NODE_ENV === 'production';

  // For scheduler.
  const isPublicScheduler = ['/scheduler/view/', '/scheduler/reschedule/', '/scheduler/cancel/']
    .some(path => location.pathname?.includes(path));

  if (isInvoicePage || isEventPage || isPublicScheduler) {
    return (
      <Container className="App">
        <Routes />
      </Container>
    );
  };

  // Set up new url for note/template previews.
  const notesMatch = useRouteMatch('/app/v2/note-viewer/:noteId');
  const templateMatch = useRouteMatch('/app/v2/note-template-viewer/:templateId');

  // If url is the note viewer url.
  if (notesMatch) {
    const { noteId } = notesMatch.params;

    return (
      <Rollbar>
        <Container className="App">
          <NotePreview
            encryptedID={noteId}
            isTemplate={false}
          />
        </Container>
      </Rollbar>
    );
  }

  if (templateMatch) {
    const { templateId } = templateMatch.params;

    return (
      <Rollbar>
        <Container className="App">
          <NotePreview
            encryptedID={templateId}
            isTemplate
          />
        </Container>
      </Rollbar>
    );
  }

  return (
    <Rollbar>
      <ApolloProvider client={client}>
        <ThemeProvider theme={muiTheme}>
          <CacheBuster
            currentVersion={process.env.REACT_APP_VERSION}
            isEnabled={isProduction}
            isVerboseMode={false}
          >
            <StyledEngineProvider injectFirst>
              <App />
            </StyledEngineProvider>
          </CacheBuster>
        </ThemeProvider>
      </ApolloProvider>
    </Rollbar>
  );
}
